// extracted by mini-css-extract-plugin
module.exports = {"background":"related-products_background__dg135","title":"related-products_title__qwB5z","container":"related-products_container__1t9QA"};